import React from "react";
import ReactDOM from "react-dom";
import "./assets/styles";
import "./index.css";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import settings from "./settings";

settings.getCSKeys().then(({ clientId, clientSecret }) => {
  window.clientId = clientId;
  window.clientSecret = clientSecret;
  ReactDOM.render(<App />, document.getElementById("root"));

  // If you want your app to work offline and load faster, you can change
  // unregister() to register() below. Note this comes with some pitfalls.
  // Learn more about service workers: https://bit.ly/CRA-PWA
  serviceWorker.unregister();
  // serviceWorker.register();
});
